import { moduleProviderFactory } from "mrb/core";
import {
    NakiMobileHomeSectionList,
    NakiMobileEmbeddedHomeSectionList,
    NakiMobileHandheldHomeSectionList,
    NakiMobileHandheldPinkHomeSectionList,
    NakiMobileHomeScreen,
    NakiMobileFeaturedSection,
    NakiMobileEmbeddedFeaturedSection,
    NakiMobileHandheldFeaturedSection,
    NakiMobileHandheldPinkFeaturedSection,
    FeaturedSection,
} from "administration/naki-mobile/pages";
import {
    NakiMobileHomeSectionListRouteStore,
    NakiMobileEmbeddedHomeSectionListRouteStore,
    NakiMobileHandheldHomeSectionListRouteStore,
    NakiMobileHandheldPinkHomeSectionListRouteStore,
    NakiMobileHomeScreenRouteStore,
    NakiMobileFeaturedSectionRouteStore,
    NakiMobileEmbeddedFeaturedSectionRouteStore,
    NakiMobileHandheldFeaturedSectionRouteStore,
    NakiMobileHandheldPinkFeaturedSectionRouteStore,
    FeaturedSectionRouteStore,
} from "administration/naki-mobile/stores";

(function () {
    moduleProviderFactory.module("administration").register({
        name: "NakiMobile",
        routes: [
            {
                name: "master.administration.naki-mobile",
                pattern: "/naki-mobile",
                children: [
                    {
                        name: "master.administration.naki-mobile.sections",
                        pattern: "sections",
                        store: NakiMobileHomeScreenRouteStore,
                        component: NakiMobileHomeScreen,
                        children: [
                            {
                                name: "master.administration.naki-mobile.sections.mobile",
                                pattern: "",
                                component: NakiMobileHomeSectionList,
                                store: NakiMobileHomeSectionListRouteStore,
                            },
                            {
                                name: "master.administration.naki-mobile.sections.mobile-embedded",
                                pattern: "",
                                component: NakiMobileEmbeddedHomeSectionList,
                                store: NakiMobileEmbeddedHomeSectionListRouteStore,
                            },
                            {
                                name: "master.administration.naki-mobile.sections.mobile-handheld",
                                pattern: "",
                                component: NakiMobileHandheldHomeSectionList,
                                store: NakiMobileHandheldHomeSectionListRouteStore,
                            },
                            {
                                name: "master.administration.naki-mobile.sections.mobile-handheld-pink",
                                pattern: "",
                                component: NakiMobileHandheldPinkHomeSectionList,
                                store: NakiMobileHandheldPinkHomeSectionListRouteStore,
                            },
                        ],
                    },
                    {
                        name: "master.administration.naki-mobile.featured-section",
                        pattern: "featured-section",
                        store: FeaturedSectionRouteStore,
                        component: FeaturedSection,
                        children: [
                            {
                                name: "master.administration.naki-mobile.featured-section.mobile",
                                pattern: "",
                                component: NakiMobileFeaturedSection,
                                store: NakiMobileFeaturedSectionRouteStore,
                            },
                            {
                                name: "master.administration.naki-mobile.featured-section.mobile-embedded",
                                pattern: "naki-bolt",
                                component: NakiMobileEmbeddedFeaturedSection,
                                store: NakiMobileEmbeddedFeaturedSectionRouteStore,
                            },
                            {
                                name: "master.administration.naki-mobile.featured-section.mobile-handheld",
                                pattern: "kedayo",
                                component: NakiMobileHandheldFeaturedSection,
                                store: NakiMobileHandheldFeaturedSectionRouteStore,
                            },
                            {
                                name: "master.administration.naki-mobile.featured-section.mobile-handheld-pink",
                                pattern: "kedayo-pink",
                                component: NakiMobileHandheldPinkFeaturedSection,
                                store: NakiMobileHandheldPinkFeaturedSectionRouteStore,
                            },
                        ],
                    },
                ],
            },
        ],
        menu: [
            {
                title: "ADMINISTRATION.MENU.NAKI_MOBILE",
                order: 12,
                icon: "mobile",
                subMenu: [
                    {
                        title: "ADMINISTRATION.MENU.NAKI_MOBILE_HOME_SCREEN",
                        order: 1,
                        route: "master.administration.naki-mobile.sections.mobile",
                    },
                    {
                        title: "ADMINISTRATION.MENU.NAKI_MOBILE_FEATURED_SECTION",
                        order: 2,
                        route: "master.administration.naki-mobile.featured-section.mobile",
                    },
                ],
            },
        ],
    });
})();
